(function (global, factory) {
  var api = factory();

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  global.JackeryCampaignCountdown = api;

  if (global.document) {
    function boot() {
      api.boot(global.document);
    }

    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', boot, { once: true });
    } else {
      boot();
    }

    global.document.addEventListener('shopify:section:load', function (event) {
      api.setup(event.target.querySelector('[data-jk-section]'));
    });
  }
}(typeof window !== 'undefined' ? window : globalThis, function () {
  function getPhase(now, start, end) {
    if (now < start) return 'prelaunch';
    if (now < end) return 'live';
    return 'expired';
  }

  function getRemainingParts(now, target) {
    var remaining = Math.max(0, target - now);
    return {
      days: Math.floor(remaining / 86400000),
      hours: Math.floor((remaining % 86400000) / 3600000),
      minutes: Math.floor((remaining % 3600000) / 60000)
    };
  }

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function render(root, now) {
    if (!root) return;

    var start = new Date(root.dataset.jkStart);
    var end = new Date(root.dataset.jkEnd);
    var phase = getPhase(now, start, end);
    var target = phase === 'prelaunch' ? start : end;
    var parts = getRemainingParts(now, target);
    var labels = {
      prelaunch: root.dataset.jkPrelaunch,
      live: root.dataset.jkLive,
      expired: root.dataset.jkExpired
    };

    root.querySelector('[data-jk-label]').textContent = labels[phase];
    root.querySelector('[data-jk-days]').textContent = phase === 'expired' ? '00' : String(parts.days);
    root.querySelector('[data-jk-hours]').textContent = phase === 'expired' ? '00' : pad(parts.hours);
    root.querySelector('[data-jk-minutes]').textContent = phase === 'expired' ? '00' : pad(parts.minutes);
  }

  function setup(root) {
    if (!root) return;
    if (root._jkTimer) clearInterval(root._jkTimer);
    render(root, new Date());
    root._jkTimer = setInterval(function () {
      render(root, new Date());
    }, 30000);
  }

  function boot(doc) {
    doc.querySelectorAll('[data-jk-section]').forEach(setup);
  }

  return {
    boot: boot,
    getPhase: getPhase,
    getRemainingParts: getRemainingParts,
    render: render,
    setup: setup
  };
}));
